import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  FormGroup,
  ControlLabel,
  InputGroup,
  FormControl
} from 'react-bootstrap';

class FormInput extends Component {
  static propTypes = {
    error: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    success: PropTypes.bool,
    warning: PropTypes.bool
  };

  render() {
    const {
      addonAfter,
      checkboxLabel,
      children,
      error,
      label,
      row,
      sm = 9,
      success,
      type,
      warning,
      ...props
    } = this.props;

    // if (error || warning || success) {
    //   props.hasFeedback = true;
    //   props.bsStyle = error ? 'error' : warning ? 'warning' : success ? 'success' : null;
    // }
    //
    // if (props.type === 'checkbox') {
    //   props.wrapperClassName = props.wrapperClassName || 'col-sm-offset-3 col-xs-9';
    //   return <Input type='text' {...props} />;
    // }
    // else {
    //   props.labelClassName = props.labelClassName || 'col-sm-3';
    //   props.wrapperClassName = props.wrapperClassName || 'col-sm-9';
    //   return <Input type='text' {...props} />;
    // }

    const validationState = success
      ? 'success'
      : error
      ? 'error'
      : warning
      ? 'warning'
      : null;
    const componentClass =
      type === 'select' || type === 'textarea' ? type : 'input';

    const field =
      type === 'checkbox' ? (
        <div className="checkbox">
          <label>
            <input type="checkbox" {...props} />
            {checkboxLabel}
          </label>
        </div>
      ) : (
        <FormControl componentClass={componentClass} type={type} {...props}>
          {children}
        </FormControl>
      );

    return (
      <FormGroup validationState={validationState} className={row ? 'row' : ''}>
        <div className={`col-sm-${12 - sm}`}>
          <ControlLabel>{label}</ControlLabel>
        </div>
        <div className={`col-sm-${sm}`}>
          {addonAfter ? (
            <InputGroup>
              {field}
              <FormControl.Feedback />
              <InputGroup.Addon>{addonAfter}</InputGroup.Addon>
            </InputGroup>
          ) : (
            <div>
              {field}
              <FormControl.Feedback />
            </div>
          )}
        </div>
      </FormGroup>
    );
  }
}

export default FormInput;
